import { getEventTagIconUrl } from "../IconPicker/constants";
import { TagContainer, TagIcon, TagLabel } from "./styles";

interface TagComponentProps {
    label: string;
    icon?: string;
    color?: string;
}

const TagComponent = ({ label, icon, color }: TagComponentProps) => (
	<TagContainer title={label} $color={color}>
		{icon && <TagIcon $src={getEventTagIconUrl(icon)} />}
		<TagLabel>{label}</TagLabel>
	</TagContainer>
);

export default TagComponent;
